import React from 'react';

const ToggleSwitch = ({ checked, onChange, label, disabled = false }) => {
  return (
    <label 
      className="toggle-switch" 
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: '14px',
        userSelect: 'none',
        whiteSpace: 'nowrap',
        minWidth: 'max-content'
      }}
    >
      <div 
        className="toggle-switch-track"
        style={{
          width: '36px',
          height: '20px',
          backgroundColor: checked ? '#4fa94d' : '#ccc',
          borderRadius: '10px',
          position: 'relative',
          transition: 'background-color 0.2s ease',
          opacity: disabled ? 0.5 : 1
        }}
        onClick={!disabled ? onChange : undefined}
      >
        <div 
          className="toggle-switch-thumb"
          style={{
            width: '16px',
            height: '16px',
            backgroundColor: 'white',
            borderRadius: '50%',
            position: 'absolute',
            top: '2px',
            left: checked ? '18px' : '2px',
            transition: 'left 0.2s ease',
            boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
          }}
        />
      </div>
      {label && (
        <span style={{ 
          color: disabled ? '#999' : 'var(--toggle-label-color, #333)',
          whiteSpace: 'nowrap',
          flexShrink: 0
        }}>
          {label}
        </span>
      )}
    </label>
  );
};

export default ToggleSwitch;
